import { render } from "./AccountDetail.vue?vue&type=template&id=ba2d583a&scoped=true&ts=true"
import script from "./AccountDetail.vue?vue&type=script&lang=ts"
export * from "./AccountDetail.vue?vue&type=script&lang=ts"

import "./AccountDetail.vue?vue&type=style&index=0&id=ba2d583a&lang=scss&scoped=true"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba2d583a"]])

export default __exports__